import { AutoComplete, FormInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { companyDigitalCertificateList } from "../../../../../../../services/companyDigitalCertificate.service";
import { useTranslation } from "react-i18next";

interface ISI_PNIProps {
  namePrefix: string;
}

const translationPath = "page.4uBus.register.iService.";

export const SI_PNI = memo(({ namePrefix }: ISI_PNIProps) => {
  const { t } = useTranslation();

  const getName = (fieldName: string) => `${namePrefix}.${fieldName}`;

  return (
    <>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("authUrl")}
          label={t(translationPath + "auth_url")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormInput
          size="small"
          name={getName("baseUrl")}
          label={t(translationPath + "base_url")}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name={getName("responsibleDocument")}
          label={t(translationPath + "cpf")}
          mask="000.000.000-00"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          size="small"
          name={getName("companyDigitalCertificate")}
          request={companyDigitalCertificateList}
          label={t(translationPath + "digital_certificate")}
          getOptionLabel={(option) => option.name}
          fullWidth
        />
      </Grid>
    </>
  );
});
